<template>
	<div
		class="resource-order"
		v-if="resource.order"
	>
		{{ text }}
	</div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import type { ResourceBase } from '@/interfaces/resourceInterface';
import { toTitleCase } from '@/helpers';

export default defineComponent({
	props: {
		resource: {
			type: Object as PropType<ResourceBase>,
			default: null,
		},
	},
	computed: {
		text() {
			return [
				toTitleCase(this.resource.audience),
				toTitleCase(this.resource.type),
				this.resource.order,
			].join(' ');
		},
	},
});
</script>

<style scoped lang="scss">
.resource-order {
	color: rgb(var(--rs-color-brand-grey-text));
	font-weight: bold;
	font-size: 1.15rem;
	letter-spacing: 1px;
	text-transform: uppercase;
}
</style>
